"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BronsonFormCustomSelect = void 0;
const React = require("react");
const form_validations_type_1 = require("../../../utils/validations/form-validations.type");
const selectItems_1 = require("./selectItems");
const form_utils_1 = require("../../../utils/form.utils");
const constants_1 = require("../../../utils/constants");
const form_type_1 = require("../form.type");
const BronsonFormCustomSelect = (props) => {
    const selectRef = React.useRef(null);
    const customError = 'Por favor selecciona una opción válida';
    const defaultOption = { id: '', value: '' };
    const [hasError, setError] = React.useState(false);
    const [errorMessage, setErrorMessage] = React.useState('');
    const [searchTerm, setSearchTerm] = React.useState((props.defaultValue && props.defaultValue.toString()) || '');
    const [selectedOption, setSelectedOption] = React.useState(defaultOption);
    const [showOptions, setShowOptions] = React.useState(false);
    const [optionsResult, setOptions] = React.useState(props.options);
    const stringOptions = JSON.stringify(props.options);
    React.useEffect(() => {
        setSearchTerm(props.defaultValue ? props.defaultValue.toString() : '');
    }, [props.defaultValue]);
    React.useEffect(() => {
        setOptions(props.options);
    }, [stringOptions]);
    const onBlurSelect = (event) => {
        if (!event.relatedTarget ||
            event.currentTarget !== event.relatedTarget) {
            setShowOptions(false);
        }
    };
    const onClickBar = () => {
        if (!props.isDisabled) {
            setShowOptions(true);
        }
    };
    const onChangeInput = (event) => {
        const option = props.options.find((opt) => {
            return opt.value === event.value;
        });
        const currentOption = props.writable ? event.value : option;
        if (!props.validations ||
            !props.validations.includes(form_validations_type_1.BronsonFormValidationsEnum.required)) {
            if (!event.value || currentOption) {
                props.onClick &&
                    props.onClick(currentOption || defaultOption, false);
                setError(false);
                setErrorMessage('');
                setSelectedOption(currentOption || defaultOption);
            }
            else {
                props.onClick && props.onClick(defaultOption, true);
                setError(true);
                setErrorMessage(customError);
                setSelectedOption(defaultOption);
            }
        }
        else {
            props.onClick &&
                props.onClick(currentOption || defaultOption, option ? false : true);
            setError(currentOption ? false : true);
            setErrorMessage(currentOption ? '' : customError);
            setSelectedOption(currentOption || defaultOption);
        }
        setShowOptions(true);
        setSearchTerm(event.value);
    };
    const onclickOption = (option) => {
        setSelectedOption(option);
        setShowOptions(false);
        setSearchTerm(option.value);
        setError(false);
        setErrorMessage('');
        props.onClick && props.onClick(option, false);
    };
    React.useEffect(() => {
        const optionsFilter = props.options.filter((opt) => {
            const regex = new RegExp(searchTerm, 'i');
            return regex.test(opt.value);
        });
        setOptions(optionsFilter);
    }, [searchTerm]);
    return (React.createElement("div", { id: props.elementId, ref: selectRef, onBlur: onBlurSelect, className: `c-custom-select ${showOptions ? 'is-open' : ''}`, tabIndex: props.tabIndex },
        React.createElement("div", { onClick: onClickBar },
            React.createElement(form_utils_1.WrapperBronsonFormInput, { maxLength: props.maxLength, defaultValue: searchTerm || props.defaultValue, onChange: (event) => onChangeInput(event), minLength: props.minLength || constants_1.zero, type: 'text', placeholder: props.placeholder, label: props.label, elementId: `${props.elementId}-inputSearch`, hasError: props.hasError || hasError, errorMessage: props.errorMessage || errorMessage, validations: props.validations, autocomplete: form_type_1.BronsonAutocomplete.off, isDisabled: props.isDisabled, autoFill: true },
                React.createElement("button", { className: 'c-input__addon  c-input__addon--no-background' },
                    React.createElement("i", { className: `c-icon  c-icon--[${props.icon}]`, "aria-hidden": 'true', role: 'img' })))),
        optionsResult.length > constants_1.zero && (React.createElement(selectItems_1.SelectItems, { options: optionsResult, selectedOption: selectedOption, onClick: onclickOption }))));
};
exports.BronsonFormCustomSelect = BronsonFormCustomSelect;
